import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Scroll/load reveal wrapper. Staggered reveals create the orchestrated
 * entrance the design language relies on. Honors prefers-reduced-motion.
 *
 *   <Reveal delay={0.1}>...</Reveal>
 *   <Reveal as="li" y={16}>...</Reveal>
 */
export function Reveal({
  children,
  as = 'div',
  delay = 0,
  y = 28,
  duration = 0.8,
  once = true,
  className,
  style,
}) {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;

  if (reduce) {
    const Tag = as;
    return (
      <Tag className={className} style={style}>
        {children}
      </Tag>
    );
  }

  return (
    <MotionTag
      className={className}
      style={style}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: '-8% 0px' }}
      transition={{ duration, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </MotionTag>
  );
}

export default Reveal;
